// extracted by mini-css-extract-plugin
export default {"input_wrapper":"input_input_wrapper__gMP6A","input_label":"input_input_label__mrbNq","input_field":"input_input_field__B+3-y"};